import { apiService } from './api';

export type KnowledgeLawCountry = {
  code: string;
  latestYear: number;
};

type KnowledgeLawCountriesResponse = {
  countries: KnowledgeLawCountry[];
};

export async function fetchKnowledgeLawCountries() {
  const response = await apiService.get<KnowledgeLawCountriesResponse>(
    '/knowledge/law/countries',
    undefined,
    true,
  );
  return response.countries;
}
